module.exports = __webpack_public_path__ + "static/media/Clothing.e7802080.jpeg";